module.exports = __webpack_public_path__ + "img/AssetXP_White.329756fa.svg";